module.exports = __webpack_public_path__ + "img/ItsMyHomeInRed.131d53e3.jpg";